import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Utils } from 'src/app/core/resources/utils';
import { NgxSpinnerService } from 'ngx-spinner';
import { Filter, FilterModel } from 'src/app/core/models/filter';
import { PaginationList } from 'src/app/core/models/pagination-list';
import { Permission } from 'src/app/core/resources/permission';
import { AuthService } from 'src/app/core/services/authentication.service';
import { ListFilterComponent } from 'src/app/shared/list-filter/list-filter.component';
import { FreightListService } from '../cargo-list/cargo-list.service';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { ServiceMessages } from 'src/app/core/messages/service-messages.enum';
import { ServiceRequests } from 'src/app/core/interfaces/service-requests';

@Component({
  selector: 'app-cargo-list-service-requests',
  templateUrl: './cargo-list-service-requests.component.html',
  styleUrls: ['./cargo-list-service-requests.component.scss']
})
export class CargoListServiceRequestsComponent implements OnInit {
  @ViewChild(ListFilterComponent) listFilterComponent: ListFilterComponent;
  @Input() typeList: string = 'assignedServiceRequests';
  filters: string = '';
  optionsFilter: FilterModel[] = [];
  paginationList: PaginationList = new PaginationList();
  permission = Permission;
  constructor(
    private spinner: NgxSpinnerService,
    public service: FreightListService,
    public utils: Utils,
    public authService: AuthService,
    private cdRef: ChangeDetectorRef,
    public dialog: MatDialog,
    private snackbarService: SnackBarService
  ) { }

  ngOnInit() {
    sessionStorage.setItem('_lastList', this.typeList.toString());
    this.optionsFilter = this.service.getOptionsFilter(this.typeList);
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  getListServiceRequests($event: string) {
    const serviceRequestsObserver = {
      next: (data: ServiceRequests[]) => {
        this.spinner.hide();
        if (!this.utils.isDefined(data) || data.length === 0) {
          this.paginationList.setEnablePagingScroll(false);
          data = [];
        }

        if (this.paginationList.getList().length) {
          this.paginationList.setList(
            this.paginationList.getList().concat(data)
          );
        } else {
          this.paginationList.setList(data);
        }
      },
      error: () => {
        this.spinner.hide();
        this.snackbarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
        if (!(this.paginationList.getList().length > 0)) {
          this.resetPagging();
          this.paginationList.setList([]);
        }

      }
    };
    this.spinner.show();
    this.service.getListCargoServiceRequests(
      $event,
      this.paginationList.getPageKey(),
      this.paginationList.getPageSize()
    ).subscribe(serviceRequestsObserver);
  }


  resetPagging() {
    this.paginationList.setPageKey(1);
    this.paginationList.setList([]);
    this.paginationList.setEnablePagingScroll(true);
  }

  refreshList($event?: string) {
    !this.paginationList
      ? this.paginationList.setList([])
      : this.resetPagging();

    this.filters = $event;
    this.getListServiceRequests(this.filters);
  }

  onScrollDown() {
    if (
      this.paginationList.getEnablePagingScroll()
    ) {
      this.paginationList.setPageKey(
        this.paginationList.getPageKey() + 1
      );
      this.getListServiceRequests(this.filters);
    }
  }

}
